import { Fragment, useState } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { CheckIcon } from '@heroicons/react/outline'
import { useHistory } from 'react-router-dom'
import PrimaryButton from '../../Buttons/PrimaryButton';

export default function SuccessPopUp({ currentStep }) {

  const history = useHistory();
  const [open, setOpen] = useState(true)

  return (
    <div className='my-auto'>
      <div>
        <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
          <CheckIcon className="h-6 w-6 text-green-600" aria-hidden="true" />
        </div>
        <div className="mt-3 text-center sm:mt-5">
          <h3 className="text-lg leading-6 font-medium text-gray-900"> 
            Success!
          </h3>
          <div className="mt-2">
            <p className="text-sm text-gray-500">
              Your Scan & Go consultation was successfully scheduled.
            </p>
          </div>
        </div>
      </div>
      <div className="mt-5 sm:mt-6">
        <PrimaryButton text="Back to Website" className="inline-flex justify-center w-full rounded-md shadow-sm py-2 text-base font-medium" onClick={() => history.push('/patient')}/>
      </div>
    </div>        
  )
}